import HeaderCart from '../common/headerCart';
import CheckQuantityLetters from '../components/checkQuantityLetters';

const Store = {
  openCartDrawer: true,
  openCartDrawerMobile: true,

  addItem: async function (_$form, _$parent, callback) {
    const _this = this;
    const $btnComprar = _$parent.find('[data-action="add-cart"]');
    const urlAdd = '/carrinho/adicionar';
    const url = urlAdd;
    let formSerialize = _$form.serializeArray();
    const $boxResponse = _$parent.find(
      '[data-form-product] .msg-response:not(.resp-validate)'
    );

    formSerialize = CheckQuantityLetters.setCustomizationByLetters(formSerialize);

    var quantity = _$form.find('input[name="quantity"]').val();
    //Repete as personalizações para quantidade maior que 1
    let customizations = formSerialize.filter(field => field.name.includes('customizations'));
    for (let i = 1; i < quantity; i++) {
      formSerialize = formSerialize.concat(...customizations);
    }

    if (!$btnComprar.hasClass('adding')) {

      $btnComprar.addClass('adding');

      // console.info('addItem');
      // console.info('addItem', formSerialize);

      $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: formSerialize,
      })
        .done(function (resp) {
          console.log('success');
          console.info(resp);

          if (typeof callback == 'function') {
            callback(_$form, 'produto-adicionado', resp, $boxResponse);
          } else {
            _this.addItemResult(_$form, 'produto-adicionado', resp, $boxResponse)
          }
        })
        .fail(function (resp) {
          console.log('error');
          console.error(resp);
          console.error(resp.responseText);
          console.error(resp.responseText.error);

          if (typeof callback == 'function') {
            callback(_$form, 'erro-adicionar', resp, $boxResponse);
          } else {
            _this.addItemResult(_$form, 'erro-adicionar', resp, $boxResponse);
          }
        })
        .always(function () {
          console.log('complete');
          $btnComprar.removeClass('adding');
        });
    }
  },
  addItemKit: function (products = [], _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find('[data-kit-button]');
    var $boxResponse = _$parent.find(
      '[data-form-product-kit] .msg-response:not(.resp-validate)'
    );
    var urlUpdate = '/carrinho';

    const data = {
      items: [],
    };

    products.forEach((product) => {
      var sku = product.querySelector('[name="sku"]') ? product.querySelector('[name="sku"]').value : product.querySelector('[name="sku_gift"]').value;
      var qty = product.querySelector('[name="quantity"]').value;

      // Verifica qual produto é a sacola para presente
      if (product.hasAttribute('data-bag')) {
        data.items.push({
          sku: sku,
          quantity: qty,
          customizations: ""
        });
      } else {

        let item = {
          sku: sku,
          quantity: qty,
        }

        var array = [];

        // Se existir, adiciona personalização o produto
        document.querySelectorAll('[data-customization]:checked').forEach((custom) => {

          let arrayItem = {
            [custom.getAttribute("data-group")]: custom.value,
          }

          array.push(arrayItem);

          //console.log('custom', arrayItem)
        })
        //console.log('Array', array)

        if (array.length > 0) item.customizations = array;

        console.log('Item', item)
        data.items.push(item);
      }

    });

    console.log('Data', data);

    const json_data = JSON.stringify(data);

    if (!$btnComprar.hasClass('adding')) {
      $.ajax({
        url: '/carrinho/adicionar/kit',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        xhrFields: {
          withCredentials: true,
        },
        cache: false,
        data: json_data,
        beforeSend: function () {
          $btnComprar.addClass('adding');
        },
      })
        .done(function (resp) {
          if (typeof _this.addItemResult == 'function') {
            _this.addItemResult(
              _$parent,
              'produto-adicionado',
              resp.items_count,
              $boxResponse
            );
          } else {
            _this.addItemResultDefault(
              _$parent,
              'produto-adicionado',
              resp,
              $boxResponse
            );
          }
        })
        .fail(function (resp) {
          console.log('error', resp);
          if (typeof _this.addItemResult == 'function') {
            _this.addItemResult(
              _$parent,
              'erro-adicionar',
              resp.items_count,
              $boxResponse
            );
          } else {
            _this.addItemResultDefault(
              _$parent,
              'erro-adicionar',
              resp,
              $boxResponse
            );
          }
        })
        .always(function () {
          $btnComprar.removeClass('adding');
        });
    }
  },
  deleteItem: async function (_itemId, _$item, removeItemResult) {
    var _this = this;

    if (!_$item.hasClass('removing')) {
      await $.ajax({
        url: '/carrinho',
        type: 'POST',
        dataType: 'json',
        data: {
          _method: 'delete',
          item_id: _itemId,
        },
        beforeSend: function () {
          _$item.addClass('removing');
        },
      })
        .done(function (_cart) {
          console.log('success');

          if ($('body').width() > 768) {
            if (this.openCartDrawer) {
              HeaderCart.updateCartCount(_cart);
            }
          } else {
            if (this.openCartDrawerMobile) {
              HeaderCart.updateCartCount(_cart);
            }
          }

          if (typeof removeItemResult == 'function') {
            removeItemResult(_$item, _cart);
          }
        })
        .fail(function (error) {
          console.log('erro ao remover', error.responseText);
        })
        .always(function () {
          _$item.removeClass('removing');
        });
    }
  },
  validateFormProduct: function (_$form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var $parent = _$form.closest('[data-box-produto]');
    var $btnComprar = _$form.find('[data-action="add-cart"]');
    var validated = true;
    var errors = [];

    if ($btnComprar.data('available') == 'false') {
      validated = false;
      errors.push('');
    } else {
      //  verifica se o sku foi selecionado
      if (_$form.find('[name="sku"]').val() == '') {
        validated = false;
        errors.push('Selecione um atributo para o produto');
      }

      //  verifica se a quantidade é válida
      console.log(_$form.find('input[name="quantity"]').val());
      if (_$form.find('input[name="quantity"]').val() <= 0) {
        console.log('qtd invalida');
        validated = false;
        errors.push('Quantidade indisponível');
      }
    }

    return { validated, errors };
  },
  setRespValidateProduct: function (_resp, _$form, _$boxResponse) {
    // var $boxResult = _$form.find('.resp-validate');
    var $boxResult = _$boxResponse;
    var htmlErrors = '';

    if (_resp.validated) {
      $boxResult.empty();
    } else {
      for (var i = _resp.errors.length - 1; i >= 0; i--) {
        htmlErrors += '<span class="msg error">' + _resp.errors[i] + '</span>';
      }

      $boxResult.html(htmlErrors);
    }
  },
  addItemResult: function (_$form, _typeResult, _result, _$boxResponse) {
    const _this = this;

    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find('[data-action="add-cart"]');

      $btnComprar.addClass('success');

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      HeaderCart.updateCartCount(_result.items_count);

      if ($('body').width() > 768) {
        if (_this.openCartDrawer) {
          HeaderCart.show();
        } else {
          setTimeout(() => { window.location.href = urlCart }, 150);
        }
      } else {
        if (_this.openCartDrawerMobile) {
          HeaderCart.show();
        } else {
          setTimeout(() => { window.location.href = urlCart }, 150);
        }
      }
    } else if (_typeResult == 'erro-adicionar') {
      console.log('error', _result)

      _$boxResponse.addClass('error');
      _$boxResponse.removeClass('success');

      _$boxResponse.slideDown(350);

      setTimeout(function () {
        _$boxResponse.slideUp(350);
      }, 3500);
    }
  }
}

export default Store;
